import Cursor from 'immutable-cursor';

const PATH = ['rootReducer', 'student'];

export const getStudents = (state) =>
  Cursor.from(state, PATH).deref();

export const getStudentById = (state, studentId) =>
  getStudents(state).get(studentId);



// WEBPACK FOOTER //
// ./containers/Student/accessors.js